// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2XeWP","disabled":"FileBtn_disabled__2kbqj","warn":"FileBtn_warn__3sPV5","fade":"FileBtn_fade__381BK"};